import type { CSSProperties } from 'react'
import { cn } from '@utils'

interface OmpOrderSummarySkeletonProps {
  className?: string
  style?: CSSProperties
}

const OmpOrderSummarySkeleton = ({ className = 'omp-order-summary', style }: OmpOrderSummarySkeletonProps) => {
  return (
    <div className={cn(className, 'omp-skel')} style={style} aria-hidden="true">
      <div className="omp-order-summary-items">
        <div className="omp-item-row">
          <div className="omp-item-img">
            <span className="skeleton omp-skel-fill" />
          </div>
          <div className="omp-item-body">
            <span className="skeleton omp-skel-line omp-skel-line-md omp-skel-w-60" />
            <span className="skeleton omp-skel-line omp-skel-w-35" />
            <span className="skeleton omp-skel-line omp-skel-w-45" />
          </div>
        </div>
      </div>
    </div>
  )
}

export default OmpOrderSummarySkeleton
